import { ScannerProtos } from '@benzinga/scanner-manager';
import { PresetType } from './ShortInterestScanner';

const allowedFields = [
  'averageVolume',
  'symbol',
  'sharesShortPercentOfFloat',
  'sharesShortPreviousPercentOfFloat',
  'sharesShortChange',
  'sharesShortChangePercent',
  'shortInterestRatio',
  'sharesShortValue',
  'sharesShortReceiptDate',
  'marketCap',
];

const largestIncreaseQuery = ScannerProtos.Query.create({
  fields: allowedFields,
  filtersAsString: 'sharesShortPercentOfFloat_gt_10;averageVolume_gt_100000;sharesShortPreviousPercentOfFloat_gt_0',
  limit: null,
  sortDir: ScannerProtos.SortDir.DESC,
  sortField: 'sharesShortChangePercent',
});

const largestDecreaseQuery = ScannerProtos.Query.create({
  fields: allowedFields,
  filtersAsString: 'sharesShortPercentOfFloat_gt_10;averageVolume_gt_100000;sharesShortPreviousPercentOfFloat_gt_0',
  limit: null,
  sortDir: ScannerProtos.SortDir.ASC,
  sortField: 'sharesShortChangePercent',
});

const mostShortedQuery = ScannerProtos.Query.create({
  fields: allowedFields,
  filtersAsString: 'sharesShortPercentOfFloat_gt_10',
  limit: null,
  sortDir: ScannerProtos.SortDir.DESC,
  sortField: 'sharesShortPercentOfFloat',
});

interface Preset {
  key: PresetType;
  label: string;
  query: ScannerProtos.Query;
}

export const presets: Preset[] = [
  {
    key: 'most-shorted' as PresetType,
    label: 'Most Shorted',
    query: mostShortedQuery,
  },
  {
    key: 'largest-increase' as PresetType,
    label: 'Largest Increase',
    query: largestIncreaseQuery,
  },
  {
    key: 'largest-decrease' as PresetType,
    label: 'Largest Decrease',
    query: largestDecreaseQuery,
  },
  // {
  //   key: 'highest-short-interest' as PresetType,
  //   label: 'Highest Short Interest %',
  //   query: q5,
  // },
  // {
  //   key: 'cover' as PresetType,
  //   label: 'Most Days to Cover',
  //   query: daysToCover,
  // }
];

export const configurePreset = (preset: Preset, options?: ScannerProtos.IQuery) => {
  return {
    ...preset,
    query: ScannerProtos.Query.create({
      ...preset.query,
      ...(options || {}),
    }),
  };
};
